import { render } from "./NonTeachingStaffView.vue?vue&type=template&id=09e7fa8e"
import script from "./NonTeachingStaffView.vue?vue&type=script&lang=js"
export * from "./NonTeachingStaffView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__